import styles from './style.postcss';
import React, { Component } from 'react';
import classnames from 'classnames';
import { Dialog, Button, testClass, ErrorDialog } from 'omni-common-ui';
import { fetch, buildUrl } from 'domain/Api';
import Detailsboard from 'components/Detailsboard';
import ReactGA from 'react-ga4';
import PropTypes from 'prop-types';

class HomeworkContentPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homeworkContentItems: [],
      isErrored: false,
      isLoading: true,
    };
  }

  componentDidMount() {
    const { url } = this.props;
    fetch(buildUrl(url))
      .then((response) => {
        this.setState({
          homeworkContentItems: response,
          isLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          isErrored: true,
          isLoading: false,
        });
      });
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      location: window.location.href,
      title: document.title,
      modal: `homework-content/${url}`,
    });
  }

  render() {
    const { homeworkContentItems, isErrored, isLoading } = this.state;
    const { onOkButtonClicked, title } = this.props;
    const buttonWrapper = (
      <Button.Container align="center">
        <Button type={Button.Type.primary} onClick={() => onOkButtonClicked()}>
          OK
        </Button>
      </Button.Container>
    );
    let popupContent = (
      <p
        className={classnames(
          testClass('loading'),
          styles.HomeworkContentPopup_loading,
        )}
      />
    );
    if (isErrored) {
      return <ErrorDialog isOpen onConfirmClick={onOkButtonClicked} />;
    } else if (!isLoading) {
      popupContent = (
        <div className={styles.HomeworkContentPopup}>
          <h2 className={styles.HomeworkContentPopup_title}>{title}</h2>
          <div className={styles.HomeworkContentPopup_content}>
            {homeworkContentItems.map((homeworkContentItem) => {
              const { name, description } = homeworkContentItem;
              return (
                <Detailsboard
                  key={name}
                  boardTitle={name}
                  boardValue={description}
                />
              );
            })}
          </div>
          {buttonWrapper}
        </div>
      );
    }
    return (
      <Dialog isOpen isLoading={isLoading}>
        {popupContent}
      </Dialog>
    );
  }
}

HomeworkContentPopup.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  onOkButtonClicked: PropTypes.func,
};

export default HomeworkContentPopup;



// WEBPACK FOOTER //
// ./containers/Group/Homework/HomeworkContentPopup/index.jsx